import download from 'downloadjs';
import slugify from 'slugify';

import Http from '../../../http';

export const validateOrder = (shopId, payload) => {
  return Http.post(`/shop/${shopId}/purchase-order/validate`, payload);
};

export const generateOrder = (shopId, payload) => {
  return Http.post(`/shop/${shopId}/purchase-order/generate`, payload);
};

export const downloadOrderPdf = (shopId, order) => {
  const filename = `${
    order.formattedPoNumber
  }-${
    order.formattedDateCreated.replaceAll(' ', '')
  }-${
    slugify(order.vendorName, {
      replacement: '_',
      strict: true,
      remove: /"<>#%\{\}\|\\\^~\[\]`;\?:@=&/g,
    })
  }.pdf`;

  return Http.postWithRawResponse(`/shop/${shopId}/purchase-order/${order.id}/export`)
    .then(response => download(response, filename, 'application/pdf'));
};
